module.exports = __webpack_public_path__ + "img/homefounder_logo_mobile.svg";